var map = {
	"./bag.svg": "47fd",
	"./clap-anim.svg": "f1c3",
	"./clap.svg": "02b1",
	"./clock.svg": "755b",
	"./diploma.svg": "389a",
	"./family-anim.svg": "5fef",
	"./family.svg": "19fa",
	"./favorite-anim.svg": "cf51",
	"./favorite.svg": "2bd7",
	"./flash-anim.svg": "e005",
	"./flash.svg": "782a",
	"./food-ticket.svg": "ce24",
	"./gallery.svg": "6ec0",
	"./graph-grow.svg": "11ca",
	"./hands-anim.svg": "e2b9",
	"./hands.svg": "8994",
	"./head-think-anim.svg": "4118",
	"./head-think.svg": "d6fd",
	"./head.svg": "1e7c",
	"./house.svg": "750c",
	"./language.svg": "a25c",
	"./money-hand.svg": "970f",
	"./person-question.svg": "e0ba",
	"./person-write.svg": "417c",
	"./person.svg": "d104",
	"./phone.svg": "c3bb",
	"./sale.svg": "681b",
	"./spa.svg": "3747",
	"./sport.svg": "8c4c",
	"./star.svg": "cc90",
	"./student.svg": "240f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";